var more = "https://shopfront-cdn.tekoapis.com/static/8e70a9b045206df7.svg";

export { more as default };
